import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {AuthenticatorModel, DeviceAuthenticatorsModel} from '../models/authenticator.model';
import {UtilsService} from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceAuthenticatorsService {

  endpoint = environment.API_URL + "rest/vsm";

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService) {
  }

  fetchDeviceAuthenticators() {
    return this.http
      .get<any>(
        this.endpoint + "/device-authenticators")
  }

  blockDevice(deviceAuthenticators: DeviceAuthenticatorsModel) {
    return this.http
      .put<any>(
        this.endpoint + "/devices/" + deviceAuthenticators.id + "/block", null
      )
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

  syncEntraPasskeys(deviceId: string) {
    return this.http
      .get<any>(
        this.endpoint + "/devices/" + deviceId + "/syncEntraPasskeys"
      )
  }

  unblockDevice(deviceAuthenticators: DeviceAuthenticatorsModel) {
    return this.http
      .put<any>(
        this.endpoint + "/devices/" + deviceAuthenticators.id + "/unblock", null)
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

  removeDevice(deviceAuthenticators: DeviceAuthenticatorsModel) {
    return this.http
      .delete<any>(
        this.endpoint + "/devices/" + deviceAuthenticators.id)
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

  removeAuthenticator(authenticator: AuthenticatorModel) {
    return this.http
      .delete<any>(
        this.endpoint + "/authenticators/" + authenticator.id
      )
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

  removeEntraAuthenticator(authenticator: AuthenticatorModel) {
    return this.http
      .delete<any>(
        this.endpoint + "/entra-key/" + authenticator.id
      )
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

}
